(($) => {
    'use strict';

    $('.tooltips').tooltip();
})(jQuery);
